module.exports = __webpack_public_path__ + "img/Villa_Borna_13.a1e5fc42.jpg";